import * as types from "../constants/actionTypes";
import initialState from "./initialState";

export const payment = (state = initialState.payment, action) => {
  switch (action.type) {
    case types.GET_PAYMENT_URL_SUCCEED: {
      return action.payload;
    }
    case types.GET_PAYMENT_URL_FAILED: {
      return state;
    }
    default:
      return state;
  }
};

export const paymentUrlRequestStatus = (state = true, action) => {
  switch (action.type) {
    case types.GET_PAYMENT_URL_SUCCEED: {
      return true;
    }
    case types.GET_PAYMENT_URL_FAILED: {
      return false;
    }
    default:
      return state;
  }
};

export const reservationId = (state = null, action) => {
  switch (action.type) {
    case types.SET_RESERVATION_SUCCEED: {
      return action.payload;
    }
    case types.SET_RESERVATION_FAILED: {
      return state;
    }
    default:
      return state;
  }
};

export const payPalUrl = (state = "", action) => {
  switch (action.type) {
    case types.PAYPAL_PROXY_SUCCEED: {
      return action.payload && action.payload.URL;
    }
    case types.PAYPAL_PROXY_FAILED: {
      return state;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/paymentReducer.js